import { SORT_ORDER } from '../constants/filter.constant';
import { DefaultResponse } from '../interfaces/index';
import api from '../api';
import { AxiosResponse } from 'axios';

const BODYPART_URL = '/ris/dashboard/v1/bodyparts';

export interface ParamsGetBodyPart {
  limit: number;
  offset: number;
  sort_field?: '' | 'name' | 'created_at' | 'updated_at';
  sort_order?: SORT_ORDER;
}
export interface ResponseGetBodyPart extends DefaultResponse {
  data: {
    created_at: string;
    id: string;
    name: string;
    updated_at: string;
  }[];
}
export const getBodyParts = async (
  params: ParamsGetBodyPart = {
    limit: 100,
    offset: 0,
  }
) => {
  const response = (await api({
    url: BODYPART_URL,
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseGetBodyPart>;

  return response.data;
};

export interface ParamsCreateBodyPart {
  name: string;
}
export const createBodyPart = async (data: ParamsCreateBodyPart) => {
  const response = (await api({
    url: BODYPART_URL,
    method: 'POST',
    data,
  })) as AxiosResponse<ResponseGetBodyPart>;

  return response.data;
};

export const updateBodyPart = async (id: string, data: ParamsCreateBodyPart) => {
  const response = (await api({
    url: `${BODYPART_URL}/${id}`,
    method: 'PUT',
    data,
  })) as AxiosResponse<ResponseGetBodyPart>;

  return response.data;
};

export const deleteBodyPart = async (id: string) => {
  return (await api({
    url: `${BODYPART_URL}/${id}`,
    method: 'DELETE',
  })) as AxiosResponse<any>;
};
